import { NJModal, NJModalContent, NJButton, NJInlineMessage, NJLink } from '@engie-group/fluid-design-system-react';
import { message, Upload } from 'antd';
import { useState, useEffect } from 'react';
import './ModalDataUpload.css';
import { InboxOutlined } from '@ant-design/icons';
import { apiGatewayConfig, oktaEnabled } from '../../../config';


const { Dragger } = Upload;

function ModalDataUpload({ isOpen, id, oktaAuth, handleProcessFile, handleCancel }) {

    const [token, setToken] = useState();
    const [uploadedFilename, setUploadedFilename] = useState('');

    useEffect(() => {
        setUploadedFilename('');
    }, [isOpen]);

    // Get OKTA token
    // Move async operation to useEffect
    useEffect(() => {
        const getToken = async () => {
            if (oktaEnabled) {
                const newToken = await oktaAuth.getOrRenewAccessToken();
                setToken(newToken);
            } else {
                const localToken = localStorage.getItem('force-token') || undefined;
                setToken(localToken);
            }
        };

        getToken();
    }, [oktaAuth]);

    const uploadUrl = `${apiGatewayConfig.apiBaseUrl}/${apiGatewayConfig.endpointAdminDataUpload}`;

    const props = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: '.xlsx',
        action: uploadUrl,
        withCredentials: true,
        headers: {
            'Authorization': `Bearer ${token}`,
        },
        // Add custom request to handle file upload
        customRequest: async ({ file, onSuccess, onError }) => {
            try {
                const formData = new FormData();
                formData.append('file', file);

                const response = await fetch(uploadUrl, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'content-disposition': `attachment; filename="${file.name}"`,
                    },
                    body: formData
                });
                if (!response.ok) throw new Error('Upload failed');

                const result = await response.json();
                onSuccess(result, file);
            } catch (error) {
                console.error('Upload error:', error);
                onError(error);
            }
        },
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
            }
            if (status === 'removed') {
                setUploadedFilename('');
            }
            if (status === 'done') {
                setUploadedFilename(info?.file?.response?.filename);
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
        },
    };

    return (
        <>
            <NJModal
                id="modalDataUpload"
                isOpen={isOpen}
            >
                <NJModalContent
                    footer={
                        <>
                            <NJButton
                                emphasis="bold"
                                variant="secondary"
                                label="Cancel"
                                onClick={handleCancel}
                            />
                            <NJButton
                                label="Process file"
                                icon="sync"
                                iconClassName="material-icons-outlined"
                                disabled={!uploadedFilename}
                                onClick={() => { handleProcessFile(uploadedFilename) }}
                            />
                        </>
                    }
                    icon="upload"
                    id="modalDataUpload"
                    onClose={handleCancel}
                    title="Import configuration Excel file"
                >
                    <NJInlineMessage
                        action={<NJLink href="#" variant="high_contrast">Compliance rules</NJLink>}
                        variant="warning"
                    >
                        The column names have to be compliant.
                    </NJInlineMessage>

                    <div className="modal-data-upload-dropzone">
                        <Dragger {...props}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint">
                                Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                                banned files.
                            </p>
                        </Dragger>
                    </div>

                </NJModalContent>
            </NJModal>
        </>
    )
}

export default ModalDataUpload;
